namespace Matrix.Data {
    export class DataParameterListColumns {
        static columnsKey = 'Matrix.Data.Columns.DataParameterListColumns';
    }
}
